import * as React from "react";
import { useState, useEffect } from "react";
import { MeiliSearch } from 'meilisearch'




function Import_(props){

  const client = new MeiliSearch({
    host:  props.meilisearchUrl,
    apiKey: 'S49gaMiDZYR0y5b-dLTT6AtcbyBx6LNK74XON69J_kA',
  })

  useEffect(() => {
    import_data()
  }, [])

  const import_data = async () => {
    // resouces
    client.index('Resource').updateFilterableAttributes([
      'hidden'
    ])
    const resouces_index = client.index('Resource')
    let resp = await resouces_index.addDocuments(props.resources, { primaryKey: 'id' })
    // console.log('resouces added!', resp);

    // resouce_categories  
    client.index('ResourceCategory').updateFilterableAttributes([
      'hidden'
    ])
    const resouce_categories_index = client.index('ResourceCategory')
    resp = await resouce_categories_index.addDocuments(props.resourceCategories, { primaryKey: 'id' })
    // console.log('resouce categories added!', resp);
    
    // courses  
    client.index('Library_Course').updateFilterableAttributes([
      'status',
      'hidden'
    ])
    const courses_index = client.index('Library_Course')
    resp = await courses_index.addDocuments(props.courses, { primaryKey: 'id' })
    // console.log('courses added!', resp);

    // quotes  
    client.index('QuoteCalculator_Quote').updateFilterableAttributes([
      'organization_id',
      'discarded_at'
    ])
    const quotes_index = client.index('QuoteCalculator_Quote')
    resp = await quotes_index.addDocuments(props.quotes, { primaryKey: 'id' })
    // console.log('quotes added!', resp);
  }

  return(
    <div>
      <h2>Import Ran!</h2>
    </div>
  )
}

export default Import_


// WEBPACK FOOTER //
// ./app/javascript/components/pages/Import.tsx